import React, { useEffect, useState } from "react";
import { useParams, useLocation, NavLink, useNavigate, useSearchParams } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import DecryptData from "../../service/DecryptData";
//import JobFilterData from "../../json/jobFilter.json";
import ReactPaginate from 'react-paginate';

interface KeyValue {
  value: string;
}
interface Job {
  jobId: string;
  jobTitle: string;
  jobDescription: string;
  location: string;
  jobCategory: string;
  jobType: string,
  workProfile: string,
  experience: string,
  noOfOpenings: number,
  keyResponsibility: KeyValue[],
  technologySkills: KeyValue[],
  requiredQualification: KeyValue[],
  workingConditions?: KeyValue[],
  ourDetails: string,
  ourOffer: KeyValue[],
  additionalInformation: KeyValue[],
  status: string,
  effectiveFrom: string,
  effectiveTo: string,
  createdOn: string
}

interface SearchResultProps {
  bannerSearchText: string;
  onFiltersChange: (filters: {
    category: Set<string>;
    jobType: Set<string>;
  }) => void;
  jobSpecifications: Job[];
  jobCategories: Job[];
  jobTypes: Job[];
}

const SearchResult: React.FC<SearchResultProps> = ({ onFiltersChange,
  bannerSearchText,
  jobSpecifications,
  jobCategories,
  jobTypes
}) => {
  const tabRoute = useLocation();
  const navigation = useNavigate();
  const queryParams = new URLSearchParams(tabRoute.search);
  if (queryParams.size == 0) {
    //queryParams.set("source", "");
  }
  // if (tabRoute.hash.includes("#tab2?source=")) {
  //   const sourceValue = tabRoute.hash.split('?')[1].split('=')[1];
  //   queryParams.set("source", sourceValue);
  // }
  const [searchParams, setSearchParams] = useSearchParams();
  const { jobSearch } = useParams<{ jobSearch: string }>();
  const [interSearchFilter, setInterSearchFilter] = useState("");
  const [totalJobCount, setTotalJobCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [activeKeys, setActiveKeys] = useState<string[]>([]);
  const [searchInputs, setSearchInputs] = useState<{ [key: number]: string }>({});
  const [googleADService, setGoogleADService] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<{
    category: Set<string>;
    jobType: Set<string>;
  }>({
    category: new Set(),
    jobType: new Set(),
  });

  useEffect(() => {
    if (queryParams.size > 0) {
      if(DecryptData(queryParams.get('source') || "", process.env.REACT_APP_CAREER_KEY || "").toLocaleLowerCase() === 'googleadservice'){
        setGoogleADService(true);
      }      
    } 
    else if(tabRoute.hash.includes("#tab2?source")){
      const sourceValue = tabRoute.hash.split("?")[1].split("=")[1]
      const decryptHashParam = DecryptData(sourceValue, process.env.REACT_APP_CAREER_KEY || "");
      if(decryptHashParam.toLocaleLowerCase() === 'googleadservice'){
        setGoogleADService(true);
      }
    }
    else {
      tabRoute.hash.split("?")[1].split("=")[1].split('&').forEach((hashParam) => {
          const matchedCategory = jobCategories.find(item => item.jobCategory.replaceAll(" & ", "-")
            .replaceAll(" ", "-").toLocaleLowerCase() === hashParam);
         if (matchedCategory) {
            setSelectedFilters(prevFilters => {
              const updatedFilters = { ...prevFilters };
              updatedFilters.category.add(matchedCategory.jobCategory);
              updatedFilters.jobType.add(matchedCategory.jobType);
              onFiltersChange(updatedFilters);
              return updatedFilters;
            });
          } 
      });
    }
    setActiveKeys(['1']);
    setCurrentPage(0);

  }, [jobCategories]);

  useEffect(() => {
    if (selectedFilters.category.size > 0 || selectedFilters.jobType.size > 0) {
      jobOpeningCount();
    } else {
      let jobVacant = 0;
      jobSpecifications.filter((job: any) => job.status === "Published").forEach(element => {
        jobVacant += element.noOfOpenings;
      });
      setTotalJobCount(jobVacant);
    }
  }, [jobSpecifications, selectedFilters]);
  
  useEffect(() => {
    if (interSearchFilter !== "") {
      let jobVacant = 0;
      const filtereJobs = jobSpecifications.filter(job =>
      (selectedFilters.category.size === 0 || selectedFilters.category.has(job.jobCategory)) &&
      (selectedFilters.jobType.size === 0 || selectedFilters.jobType.has(job.jobType)) &&
      (job.jobTitle.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase()) || job.jobId.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase())
        || job.jobDescription.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase()) || job.location.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase())
        || job.jobType.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase()))).forEach(element =>{
          jobVacant += element.noOfOpenings;
      });
      setTotalJobCount(jobVacant);
      setCurrentPage(0);
    }
  }, [interSearchFilter]);
  const filteredJobResults = bannerSearchText !== "" ? jobSpecifications.filter(job =>
    job.jobTitle.includes(bannerSearchText) || job.jobDescription.includes(bannerSearchText) ||
    job.jobId.includes(bannerSearchText) || job.location.includes(bannerSearchText) || job.jobType.includes(bannerSearchText))
    : interSearchFilter !== "" ? jobSpecifications.filter(job =>
      (selectedFilters.category.size === 0 || selectedFilters.category.has(job.jobCategory)) &&
      (selectedFilters.jobType.size === 0 || selectedFilters.jobType.has(job.jobType)) &&
      (job.jobTitle.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase()) || job.jobId.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase())
        || job.jobDescription.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase()) || job.location.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase())
        || job.jobType.toLocaleLowerCase().includes(interSearchFilter.toLocaleLowerCase())))

      : jobSpecifications.filter(job =>
        (selectedFilters.category.size === 0 || selectedFilters.category.has(job.jobCategory)) &&
        (selectedFilters.jobType.size === 0 || selectedFilters.jobType.has(job.jobType)));

  const hasJobResults = filteredJobResults?.length > 0;
  const totalPosition = filteredJobResults.length;

  const handleRemoveCategoryFilter = (category: string) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = new Set(prevFilters.category);
      updatedFilters.delete(category);
      handleSearchParams(category, prevFilters, "remove");
      return { ...prevFilters, category: updatedFilters };
    });
  };

  const handleRemoveJobTypeFilter = (jobType: string) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = new Set(prevFilters.jobType);
      updatedFilters.delete(jobType);
      return { ...prevFilters, jobType: updatedFilters };
    });
  };

  const handleInterSearchFilter = (e: any) => {
    setInterSearchFilter(e.target.value);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const clearFilters = () => {
    const clearedFilters = {
      category: new Set<string>(),
      jobType: new Set<string>(),
    };
    setSelectedFilters(clearedFilters);
    onFiltersChange(clearedFilters);
    handleSearchParams("", clearedFilters, "Clear");
  };

  const handleSelect = (eventKey: string | null) => {
    if (!eventKey) return;
    setActiveKeys((prevActiveKeys) => {
      if (prevActiveKeys.includes(eventKey)) {
        return prevActiveKeys.filter((key) => key !== eventKey);
      } else {
        return [...prevActiveKeys, eventKey];
      }
    });
  };


  const renderIcon = (eventKey: string) => {
    return activeKeys.includes(eventKey) ? (
      <span className="icon icon-minus"></span>
    ) : (
      <span className="icon icon-plus"></span>
    );
  };

  const handleSearchChange = (index: number, value: string) => {
    setSearchInputs((prevState) => ({
      ...prevState,
      [index]: value,
    }));
  };

  const filterItems = (filterIndex: string) => {
    if (filterIndex === "1") {
      return jobCategories.filter(item => {
        return Object.keys(searchInputs).every((key) => {
          const searchValue = searchInputs[parseInt(key)];
          if (searchValue && key === "1") {
            return item.jobCategory.toLowerCase().includes(searchValue.toLowerCase())
          }
          return true;
        });
      });
    }
    else if (filterIndex === "2") {
      return jobTypes.filter(item => {
        return Object.keys(searchInputs).every((key) => {
          const searchValue = searchInputs[parseInt(key)];
          if (searchValue && key == "2") {
            return item.jobType.toLowerCase().includes(searchValue.toLowerCase());
          }
          return true;
        });
      });
    }
    return [];
  };

  const handleCheckboxChange = (
    sectionTitle: string,
    value: string,
    checked: boolean
  ) => {
    setSelectedFilters((prevFilters) => {
      const updatedFilters = { ...prevFilters };
      if (sectionTitle === "Category") {
        if (checked) {
          updatedFilters.category.add(value);
          handleSearchParams(value, prevFilters, 'add');
        } else {
          updatedFilters.category.delete(value);
          handleSearchParams(value, prevFilters, 'remove');
        }
      } else if (sectionTitle === "JobType") {
        if (checked) {
          updatedFilters.jobType.add(value);
        } else {
          updatedFilters.jobType.delete(value);
        }
      }
      onFiltersChange(updatedFilters);
      return updatedFilters;
    });
  };

  const handleSearchParams = ((filterParams: string, prevFilters: any, action: string) => {
    if (action === "add") {
      if (prevFilters.category.size > 1) {
        const hashValue = tabRoute.hash + '&' + filterParams.replaceAll(" & ", "-")
          .replaceAll(" ", "-").toLocaleLowerCase();
        navigation({ hash: hashValue, search: tabRoute.search });
      } else {
        const hashValue = tabRoute.hash + filterParams.replaceAll(" & ", "-")
          .replaceAll(" ", "-").toLocaleLowerCase();
        navigation({ hash: hashValue, search: tabRoute.search });
      }
    }
    else if (action === "remove") {
      const searchValues = tabRoute.hash.split('=')[1];
      let searchParams = "";
      let searchValueIndex = 0;
      searchValues.split('&').forEach((item: string, index: number) => {
        if (item !== filterParams.replaceAll(" & ", "-")
          .replaceAll(" ", "-").toLocaleLowerCase()) {
          if (searchValueIndex == 0) {
            searchParams = item;
            searchValueIndex++;
          } else {
            searchParams = searchParams + '&' + item;
          }
        }
      });
      const modifyUrl = tabRoute.hash.split('=')[0] + '=' + searchParams;
      navigation({ hash: modifyUrl, search: tabRoute.search });
    } else {
      const modifyUrl = tabRoute.hash.split('=')[0] + '=';
      navigation({ hash: modifyUrl, search: tabRoute.search });
    }
  });

  // Function to accordion visibility in mobile view
  const [isAccordionVisible, setAccordionVisible] = useState(false);
  const handleToggleAccordion = () => {
    setAccordionVisible(!isAccordionVisible);
    document.body.classList.add('hidden-bg');
  }
  const closeFilterBox = () => {
    setAccordionVisible(false);
    document.body.classList.remove('hidden-bg');
  };

  const itemsPerPage = 6
  const startIndex = currentPage;
  const currentItems = filteredJobResults.slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(filteredJobResults.length / itemsPerPage);


  const handlePageClick = (event: any) => {
    const newOffset = (event.selected * itemsPerPage) % filteredJobResults.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setCurrentPage(newOffset);
  };

  const jobOpening = (itemName: string) => {
    let jobVacant = 0;
    let jobsCategory = jobSpecifications.filter((job: any) => job.jobCategory === itemName);
    jobsCategory.forEach(element => {
      jobVacant += element.noOfOpenings;
    });
    return jobVacant;
  };
  const jobTypeCount = (itemName: string) => {
    let jobTypeCount = 0;
    if (selectedFilters.category.size > 0) {
      selectedFilters.category.forEach(element => {
        let jobTypes = jobSpecifications.filter((job: any) => job.jobType === itemName && job.jobCategory === element);
        jobTypes.forEach(element => {
          jobTypeCount += element.noOfOpenings;
        });
      });
    } else {
      let jobTypes = jobSpecifications.filter((job: any) => job.jobType === itemName);
      jobTypes.forEach(element => {
        jobTypeCount += element.noOfOpenings;
      });
    }
    return jobTypeCount;
  }
  const jobOpeningCount = () => {
    let jobOpeningCount = 0;

    selectedFilters.category.forEach(category => {
      jobSpecifications.filter((job: any) => job.jobCategory === category).forEach(element => {
        jobOpeningCount += element.noOfOpenings;
      });
    });
    if (selectedFilters.jobType.size > 0 && selectedFilters.category.size == 0) {
      jobOpeningCount = 0;
      jobSpecifications.filter((job: any) => selectedFilters.jobType.has(job.jobType))
        .forEach(element => {
          jobOpeningCount += element.noOfOpenings;
        });
    }
    if (selectedFilters.jobType.size > 0 && selectedFilters.category.size > 0) {
      jobOpeningCount = 0;
      jobSpecifications.filter((job: any) => selectedFilters.jobType.has(job.jobType)
        && selectedFilters.category.has(job.jobCategory)).forEach(element => {
          jobOpeningCount += element.noOfOpenings;
        });

    }
    setTotalJobCount(jobOpeningCount);
  };
  const removeHtml = (str: any) => {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return doc.body.textContent || doc.body.innerText;
  };
  const TruncatedJobDescription = (description: any) => {
    const replaceDescription = description.replace("<h3>Requirements</h3>", "").replace("<h3>Benefits</h3>", "")
    const cleanedText = removeHtml(replaceDescription);
    const truncatedDescription = cleanedText.length > 200 ? cleanedText.slice(0, 150) + '...' : cleanedText;
    return <p className="txtSize16">{truncatedDescription}</p>
  }
  return (
    <>
      {jobSpecifications.length == 0 ?
        (<>
          <div id="brf-page-loader" className="loader-fixed bgWhite container-flex-box brf-page-loader">
            <img src="../content/img/loader.gif" />
            <div className="page-loader-msg middle-align-self pad-left-10">Loading data, please wait</div></div>
        </>)
        : (<>
          <div className="bgWhite pad-15-xs">
            {isAccordionVisible && (
              <div className="search-filter-popup">
                <div className="search-filter-left-box hidden-sm hidden-lg hidden-md">
                  <div className="search-filter-left-box-header">
                    <h2 className="txtBlack txtSize20 txtSize18-xs bellSlimBold">
                      Refine your search
                    </h2>
                    <i className="icon icon-close visible-xs txtSize18 search-filter-box-close-xs" onClick={closeFilterBox}></i>
                  </div>
                  <div className="clear spacer10"></div>
                  <Accordion className="search-filter-accordion-list bgGray19"
                    activeKey={activeKeys}
                    onSelect={(e) => handleSelect(e as string | null)}>
                    <Accordion.Item eventKey="1">
                      <div className="search-filter-accordion-item">
                        <Accordion.Header>
                          <span className="search-filter-accordion-item-title bellSlim txtBold">Category</span>
                          {renderIcon("1")}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="clear spacer30"></div>
                          <div className="search-filter-result-search-bar">
                            <input
                              type="text"
                              placeholder={`Search in Category`}
                              value={searchInputs[1] || ''}
                              onChange={(e) => handleSearchChange(1, e.target.value)}
                            />
                            <div className="clear spacer20"></div>
                          </div>
                          <ul className="search-filter-accordion-sub-list">
                            {filterItems("1").map((category, index) => {
                              return (
                                <li className="search-filter-accordion-sub-item"
                                  key={index}>
                                  <input
                                    type="checkbox"
                                    name={`1-${index}`}
                                    className="search-filter-checkbox"
                                    checked={selectedFilters.category.has(category.jobCategory)}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        'Category',
                                        category.jobCategory,
                                        e.target.checked
                                      )
                                    }
                                  />
                                  <span className="search-filter-text">
                                    {category.jobCategory}&nbsp;({jobOpening(category.jobCategory)})
                                  </span>
                                </li>
                              );
                            })}
                          </ul>
                        </Accordion.Body>
                      </div>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <div className="search-filter-accordion-item">
                        <Accordion.Header>
                          <span className="search-filter-accordion-item-title bellSlim txtBold">JobType</span>
                          {renderIcon("2")}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="clear spacer30"></div>
                          <div className="search-filter-result-search-bar">
                            <input
                              type="text"
                              placeholder={`Search in JobType`}
                              value={searchInputs[2] || ''}
                              onChange={(e) => handleSearchChange(2, e.target.value)}
                            />
                            <div className="clear spacer20"></div>
                          </div>
                          <ul className="search-filter-accordion-sub-list">
                            {filterItems("2").map((item, index) => (
                              <li
                                className="search-filter-accordion-sub-item"
                                key={index}
                              >
                                <input
                                  type="checkbox"
                                  name={`2-${index}`}
                                  className="search-filter-checkbox"
                                  checked={
                                    selectedFilters.jobType.has(item.jobType)
                                  }
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      "JobType",
                                      item.jobType,
                                      e.target.checked
                                    )
                                  }
                                />
                                <span className="search-filter-text">
                                  {item.jobType}&nbsp;({jobTypeCount(item.jobType)})
                                </span>
                              </li>
                            ))}
                          </ul>
                        </Accordion.Body>
                      </div>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            )}
            <div className="container liquid-container">
              <div className="career-search-container">
                <div className="search-filter-box">
                  {!googleADService && (
                    <div className="search-filter-left-box hidden-xs">
                      <div className="search-filter-left-box-header">
                        <h2 className="txtBlack txtSize20 txtSize18-xs bellSlimBold">
                          Refine your search
                        </h2>
                      </div>
                      <div className="clear spacer10"></div>
                      <Accordion className="search-filter-accordion-list bgGray19"
                        activeKey={activeKeys}
                        onSelect={(e) => handleSelect(e as string | null)}>
                        <Accordion.Item eventKey="1">
                          <div className="search-filter-accordion-item">
                            <Accordion.Header>
                              <span className="search-filter-accordion-item-title bellSlim txtBold">Category</span>
                              {renderIcon("1")}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="clear spacer30"></div>
                              <div className="search-filter-result-search-bar">
                                <input
                                  type="text"
                                  placeholder={`Search in Category`}
                                  value={searchInputs[1] || ''}
                                  onChange={(e) => handleSearchChange(1, e.target.value)}
                                />
                                <div className="clear spacer20"></div>
                              </div>
                              <ul className="search-filter-accordion-sub-list">
                                {filterItems("1").map((category, index) => {
                                  return (
                                    <li className="search-filter-accordion-sub-item"
                                      key={index}>
                                      <input
                                        type="checkbox"
                                        name={`1-${index}`}
                                        className="search-filter-checkbox"
                                        checked={selectedFilters.category.has(category.jobCategory)}
                                        onChange={(e) =>
                                          handleCheckboxChange(
                                            'Category',
                                            category.jobCategory,
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <span className="search-filter-text">
                                        {category.jobCategory}&nbsp;({jobOpening(category.jobCategory)})
                                      </span>
                                    </li>
                                  );
                                })}
                              </ul>
                            </Accordion.Body>
                          </div>
                        </Accordion.Item>
                        <Accordion.Item eventKey="2">
                          <div className="search-filter-accordion-item">
                            <Accordion.Header>
                              <span className="search-filter-accordion-item-title bellSlim txtBold">JobType</span>
                              {renderIcon("2")}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="clear spacer30"></div>
                              <div className="search-filter-result-search-bar">
                                <input
                                  type="text"
                                  placeholder={`Search in JobType`}
                                  value={searchInputs[2] || ''}
                                  onChange={(e) => handleSearchChange(2, e.target.value)}
                                />
                                <div className="clear spacer20"></div>
                              </div>
                              <ul className="search-filter-accordion-sub-list">
                                {filterItems("2").map((item, index) => (
                                  <li
                                    className="search-filter-accordion-sub-item"
                                    key={index}
                                  >
                                    <input
                                      type="checkbox"
                                      name={`2-${index}`}
                                      className="search-filter-checkbox"
                                      checked={
                                        selectedFilters.jobType.has(item.jobType)
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          "JobType",
                                          item.jobType,
                                          e.target.checked
                                        )
                                      }
                                    />
                                    <span className="search-filter-text">
                                      {item.jobType}&nbsp;({jobTypeCount(item.jobType)})
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </Accordion.Body>
                          </div>
                        </Accordion.Item>
                      </Accordion>
                    </div>
                  )}
                  <div className="search-filter-right-box">
                    {!googleADService && (
                      <div className="">
                        <ul className="search-filters-list">
                          {Array.from(selectedFilters.category).map((category, index) => (
                            <li
                              key={`category-${index}`}
                              className="search-filters-item filter-sort-text"
                            >
                              <span>{category}</span>
                              <i
                                className="icon icon-close"
                                onClick={() => handleRemoveCategoryFilter(category)}
                              ></i>
                            </li>
                          ))}
                          {Array.from(selectedFilters.jobType).map((jobType, index) => (
                            <li
                              key={`jobType-${index}`}
                              className="search-filters-item filter-sort-text"
                            >
                              <span>{jobType}</span>
                              <i
                                className="icon icon-close"
                                onClick={() => handleRemoveJobTypeFilter(jobType)}
                              ></i>
                            </li>
                          ))}
                          {(selectedFilters.category.size > 0 ||
                            selectedFilters.jobType.size > 0) && (
                              <li className="search-filters-item" onClick={clearFilters}>
                                <span>Clear all</span>
                              </li>
                            )}
                        </ul>
                      </div>
                    )}
                    <div className="clear spacer20"></div>
                    <div className="search-filter-result-header">
                      <div className="search-filter-result-search-bar-result">
                        <input type="text" value={interSearchFilter} placeholder="Search from below list" onChange={handleInterSearchFilter} />
                      </div>
                      <div className="search-filter-result-sort-by">

                        <span>
                          Sort by :
                        </span>
                        <select>
                          <option>Most recent</option>
                        </select>
                        <a className="visible-xs txtBlue search-filter-bar-xs" onClick={handleToggleAccordion}>
                          Filter <i className="icon icon-filter"></i>
                        </a>
                      </div>
                    </div>
                    <div className="row">
                      <p className="bellSlimBold txtSize18 career-search-found">
                        {totalPosition} {totalPosition <= 1 ? "Position" : "Positions"} | {totalJobCount} {totalJobCount <= 1 ? "Opening found" : "Openings found"}
                      </p>
                    </div>
                    <div className="search-filter-result-body" id="search-filter-result-body">
                      {hasJobResults ? (
                        currentItems.map((job: any, index: number) => (
                          <div className="search-filter-result-item" key={index}>
                            <div className="content-alignright">
                              <NavLink to={`/career-details/${encodeURIComponent(job.jobId)}/${encodeURIComponent(job.jobTitle)}?${queryParams.toString()}`} className="txtBlack txtSize20">
                                {job.jobTitle}
                              </NavLink>
                            </div>
                            <div className="clear spacer10"></div>
                            <div className="search-filter-result-icons">
                              <p className="txtSize16 bellSlim txtBlack">
                                <img src="../content/img/pin-4-16.png" />
                                <span className="pad-left-10">{job.location}</span>
                              </p>
                              <p className="txtSize16 bellSlim txtBlack">
                                <img src="/content/img/flag.png" />
                                <span className="pad-left-10">{job.jobId}</span>
                              </p>
                              <p className="bellSlimBold txtSize16 floatR">{job.noOfOpenings} {job.noOfOpenings == 1 ? " Opening" : " Openings"}</p>
                            </div>
                            {TruncatedJobDescription(job.jobDescription)}
                          </div>
                        ))
                      ) : (
                        <p className="txtCenter">
                          There are no jobs for your search criteria.
                          <br />
                          Please search again.
                        </p>
                      )}
                      <ReactPaginate
                        key={totalPages}
                        nextLabel="next >"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        marginPagesDisplayed={2}
                        pageCount={totalPages}
                        previousLabel="< previous"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        containerClassName="pagination"
                        activeClassName="active"
                        renderOnZeroPageCount={null}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>)}
    </>
  );
};

export default SearchResult;